import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  'de-CH': {
    translation: {
      // Navigation
      'nav.home': 'Start',
      'nav.wizard': 'Wizard',
      'nav.dryrun': 'Vorschau',
      'nav.download': 'Download',
      'nav.admin': 'Admin',
      'nav.logout': 'Abmelden',
      'nav.login': 'Anmelden',
      
      // Landing Page
      'landing.hero.title': 'CleanStart PC Optimizer',
      'landing.hero.subtitle': '1-Klick Windows-Optimierung ohne sichtbare PowerShell',
      'landing.hero.cta': 'Jetzt optimieren',
      'landing.features.title': 'Funktionen',
      'landing.features.bloatware': 'Bloatware entfernen',
      'landing.features.bloatware.desc': 'Deaktiviere unnötige vorinstallierte Software',
      'landing.features.privacy': 'Datenschutz',
      'landing.features.privacy.desc': 'Reduziere Telemetrie und Tracking',
      'landing.features.performance': 'Leistung',
      'landing.features.performance.desc': 'Optimiere Autostarts und Dienste',
      'landing.features.rollback': 'Sicherer Rollback',
      'landing.features.rollback.desc': 'Alle Änderungen reversibel',
      
      // Auth
      'auth.login.title': 'Anmelden',
      'auth.login.subtitle': 'Melde dich an, um fortzufahren',
      'auth.register.title': 'Registrieren',
      'auth.register.subtitle': 'Erstelle ein neues Konto',
      'auth.email': 'E-Mail-Adresse',
      'auth.password': 'Passwort',
      'auth.password.confirm': 'Passwort bestätigen',
      'auth.password.new': 'Neues Passwort',
      'auth.password.min': 'Mindestens 8 Zeichen',
      'auth.login.button': 'Anmelden',
      'auth.register.button': 'Registrieren',
      'auth.switch.register': 'Noch kein Konto? Registrieren',
      'auth.switch.login': 'Bereits registriert? Anmelden',
      'auth.forgot': 'Passwort vergessen?',
      'auth.verify.title': 'E-Mail bestätigen',
      'auth.verify.subtitle': 'Gib den 6-stelligen Code ein, den wir gesendet haben an:',
      'auth.verify.button': 'Bestätigen',
      'auth.verify.resend': 'Code erneut senden',
      'auth.verify.resent': 'Neuer Code wurde gesendet!',
      'auth.verify.spamHint': 'Falls du nichts in deinem Postfach findest, schaue im Junk-/Spam-Ordner nach.',
      'auth.reset.title': 'Passwort zurücksetzen',
      'auth.reset.subtitle': 'Gib deine E-Mail-Adresse ein',
      'auth.reset.send': 'Reset-Code senden',
      'auth.reset.code.title': 'Code eingeben',
      'auth.reset.code.subtitle': 'Gib den 6-stelligen Reset-Code ein',
      'auth.reset.new.title': 'Neues Passwort',
      'auth.reset.new.subtitle': 'Wähle ein neues Passwort',
      'auth.reset.button': 'Passwort zurücksetzen',
      'auth.reset.success': 'Passwort erfolgreich zurückgesetzt!',
      'auth.reset.back': 'Zurück zur Anmeldung',
      'auth.reset.step2.next': 'Weiter',
      'auth.email.placeholder': 'name@beispiel.ch',
      
      // Toast messages
      'toast.login.success': 'Erfolgreich angemeldet!',
      'toast.login.unverified': 'E-Mail nicht verifiziert. Bitte bestätige deine E-Mail.',
      'toast.login.failed': 'Anmeldung fehlgeschlagen',
      'toast.register.passwordMin': 'Passwort muss mindestens 8 Zeichen lang sein',
      'toast.register.passwordMismatch': 'Passwörter stimmen nicht überein',
      'toast.register.success': 'Registrierung erfolgreich! Überprüfe deine E-Mails.',
      'toast.register.failed': 'Registrierung fehlgeschlagen',
      'toast.verify.incomplete': 'Bitte gib den vollständigen 6-stelligen Code ein',
      'toast.verify.success': 'E-Mail erfolgreich verifiziert!',
      'toast.verify.failed': 'Verifizierung fehlgeschlagen',
      'toast.resend.failed': 'Fehler beim Senden',
      'toast.reset.codeSent': 'Reset-Code wurde gesendet. Überprüfe deine E-Mails.',
      'toast.reset.sendFailed': 'Fehler beim Senden des Reset-Codes',
      'toast.reset.failed': 'Fehler beim Zurücksetzen',
      'toast.session.expired': 'Sitzung abgelaufen, bitte erneut anmelden',
      'toast.session.relogin': 'Bitte melde dich erneut an',
      'toast.download.success': 'Download erfolgreich!',
      'toast.download.failed': 'Download fehlgeschlagen. Bitte versuche es erneut.',
      'toast.download.noToken': 'Kein Download-Token vorhanden',
      'toast.rateLimit.tooMany': 'Zu viele Anfragen',
      'toast.rateLimit.daily': 'Tageslimit erreicht. Bitte versuche es morgen erneut.',
      
      // Wizard
      'wizard.title': 'Optimierungs-Wizard',
      'wizard.subtitle': 'Wähle die gewünschten Optimierungen',
      'wizard.select': 'Auswählen',
      'wizard.selected': 'Ausgewählt',
      'wizard.next': 'Weiter zur Vorschau',
      'wizard.norecipes': 'Keine Rezepte verfügbar',
      'wizard.selectMin': 'Bitte wähle mindestens ein Rezept',
      'wizard.steps': 'Schritte',
      'wizard.changes': 'Änderungen',
      
      // Categories
      'category.datenschutz': 'Datenschutz',
      'category.leistung': 'Leistung',
      'category.komfort': 'Komfort',

      // Dry Run
      'dryrun.title': 'Änderungsvorschau',
      'dryrun.subtitle': 'Überprüfe die geplanten Änderungen',
      'dryrun.generate': 'Paket generieren',
      'dryrun.back': 'Zurück',
      'dryrun.total': 'Gesamte Änderungen',
      'dryrun.impact': 'Geschätzte Auswirkungen',
      'dryrun.changes': 'Änderungen',
      'dryrun.category': 'Kategorie',
      'dryrun.category.datenschutz': 'Datenschutz',
      'dryrun.category.leistung': 'Leistung',
      'dryrun.category.komfort': 'Komfort',
      
      // Download
      'download.title': 'Download',
      'download.subtitle': 'Dein Optimierungspaket ist bereit',
      'download.button': 'ZIP herunterladen',
      'download.downloading': 'Wird heruntergeladen...',
      'download.expires': 'Läuft ab',
      'download.ready': 'Dein Optimierungspaket ist bereit',
      'download.instructions.title': 'Anleitung',
      'download.instructions.step1': 'ZIP-Datei entpacken',
      'download.instructions.step2': 'cleanstart.ps1 als Administrator ausführen',
      'download.instructions.step3': 'Fertig! Dein PC ist optimiert',
      'download.warning': 'Wichtig: Führe cleanstart.ps1 als Administrator aus. Das Skript erstellt automatisch einen Systemwiederherstellungspunkt.',
      'download.notAvailable': 'Download nicht verfügbar',
      'download.networkError': 'Netzwerkfehler',
      'download.retry': 'Erneut versuchen',
      'download.backToWizard': 'Zurück zum Wizard',
      'download.forbidden': 'Zugriff verweigert',
      'download.previewLoading': 'Vorschau wird geladen...',
      'download.codePreview': 'Code-Vorschau',
      'download.first50Lines': 'erste 50 Zeilen',
      'download.checksums': 'Checksums (SHA256)',
      'download.filename': 'Dateiname',
      'download.expired': 'Paket nicht gefunden oder abgelaufen',
      'download.previewFailed': 'Fehler beim Laden der Vorschau',
      'download.downloadFailed': 'Download fehlgeschlagen',
      'download.linkExpired': 'Download-Link ist abgelaufen oder wurde bereits verwendet',
      'download.notFound': 'Paket nicht gefunden',
// Download – Schritt-für-Schritt-Anleitung
      'download.guide.title': 'Schritt-für-Schritt-Anleitung',
      'download.guide.subtitle': 'Folge diesen Schritten, um das Skript korrekt auszuführen',
      'download.guide.step1': 'ZIP-Datei entpacken in einen Ordner (z.B. <code>C:\\CleanStart</code>)',
      'download.guide.step2': 'Öffne <code>cleanstart.ps1</code> mit Notepad: Rechtsklick auf die Datei → "Öffnen mit" → "Editor"',
      'download.guide.step3': 'Im Editor: <code>Strg + A</code> (alles markieren), dann <code>Strg + C</code> (kopieren)',
      'download.guide.step4': 'Drücke die Windows-Taste, tippe <code>PowerShell</code>, mache Rechtsklick auf "Windows PowerShell" → "Als Administrator ausführen" und bestätige die UAC-Abfrage mit "Ja"',
      'download.guide.step5': '<strong>Bei jedem neuen PowerShell-Fenster nötig:</strong> Tippe ein und drücke Enter (gilt nur für die aktuelle Session): <code>Set-ExecutionPolicy -Scope Process -ExecutionPolicy Bypass -Force</code>',
      'download.guide.step6': 'Füge den kopierten Skript-Inhalt mit <code>Strg + V</code> (oder Rechtsklick) ein und drücke Enter',
      'download.guide.step7': 'Das Skript erstellt automatisch einen Systemwiederherstellungspunkt und wendet die Optimierungen an (Dauer: 1-3 Minuten)',
      'download.guide.step8': 'PC bei Bedarf neu starten',
      'download.guide.undoTitle': 'Änderungen rückgängig machen:',
      'download.guide.undoText': 'Wiederhole die Schritte 2-6 mit <code>undo.ps1</code> statt <code>cleanstart.ps1</code>. Das Skript öffnet die Windows-Systemwiederherstellung.',
      // Admin
      'admin.title': 'Rezepte-Verwaltung',
      'admin.create': 'Neues Rezept',
      'admin.edit': 'Bearbeiten',
      'admin.delete': 'Löschen',
      'admin.published': 'Veröffentlicht',
      'admin.draft': 'Entwurf',
      
      // Loading Screen
      'loading.serverStarting': 'Server wird gestartet, bitte warte einen Moment...',
      'loading.serverHint': 'Kostenlose Server brauchen manchmal einen Moment zum Aufwachen',
      'loading.default': 'Wird geladen...',

      // Common
      'common.loading': 'Lädt...',
      'common.error': 'Fehler',
      'common.success': 'Erfolg',
      'common.cancel': 'Abbrechen',
      'common.save': 'Speichern',
      // i18n.js — de-CH Block, am Ende einfügen

      // Footer
      'footer.eula': 'Nutzungsbedingungen',
      'footer.privacy': 'Datenschutz',
      'footer.copyright': '© 2026 CleanStart. Alle Rechte vorbehalten.',

      // EULA Page
      'eula.title': 'Nutzungsbedingungen (EULA)',
      'eula.lastUpdated': 'Letzte Aktualisierung: 24. April 2026',
      'eula.intro': 'Durch die Nutzung von CleanStart PC Optimizer ("CleanStart") erklärst du dich mit diesen Nutzungsbedingungen einverstanden. Wenn du nicht einverstanden bist, darfst du CleanStart nicht nutzen.',
      'eula.section1.title': '1. Beschreibung des Dienstes',
      'eula.section1.text': 'CleanStart ist ein Web-basierter Generator für Windows-Optimierungsskripte. Die Skripte werden lokal auf deinem PC ausgeführt. Es werden keine Fernzugriffe oder Remote-Befehle ausgeführt.',
      'eula.section2.title': '2. Nutzung auf eigenes Risiko',
      'eula.section2.text': 'Die generierten Skripte verändern Windows-Systemeinstellungen (Registry, Dienste, geplante Aufgaben). Du bist allein verantwortlich für die Ausführung dieser Skripte. CleanStart erstellt vor jeder Optimierung automatisch einen Systemwiederherstellungspunkt, es wird dennoch empfohlen, zusätzlich ein Backup zu erstellen.',
      'eula.section3.title': '3. Keine Garantie',
      'eula.section3.text': 'CleanStart wird "wie besehen" bereitgestellt, ohne jegliche Gewährleistung. Wir übernehmen keine Haftung für Schäden, die durch die Nutzung der generierten Skripte entstehen, einschliesslich, aber nicht beschränkt auf Datenverlust, Systeminstabilität oder Funktionsverlust.',
      'eula.section4.title': '4. Geistiges Eigentum',
      'eula.section4.text': 'Die CleanStart-Software, einschliesslich aller Skripte, Rezepte und der Weboberfläche, ist urheberrechtlich geschützt. Du darfst die generierten Skripte für den persönlichen Gebrauch verwenden, jedoch nicht weiterverkaufen oder als eigene Arbeit ausgeben.',
      'eula.section5.title': '5. Kontoregeln',
      'eula.section5.text': 'Pro Person ist ein Konto erlaubt. Du bist verantwortlich für die Sicherheit deiner Zugangsdaten. Wir behalten uns vor, Konten bei Missbrauch zu sperren.',
      'eula.section6.title': '6. Änderungen',
      'eula.section6.text': 'Wir können diese Bedingungen jederzeit ändern. Bei wesentlichen Änderungen wirst du per E-Mail oder beim nächsten Login informiert. Die Weiternutzung nach einer Änderung gilt als Zustimmung.',
      'eula.section7.title': '7. Anwendbares Recht',
      'eula.section7.text': 'Es gilt Schweizer Recht. Gerichtsstand ist der Kanton Zürich.',

      // Privacy Page
      'privacy.title': 'Datenschutzerklärung',
      'privacy.lastUpdated': 'Letzte Aktualisierung: 12. Oktober 2026',
      'privacy.intro': 'Diese Datenschutzerklärung erläutert, welche Daten CleanStart PC Optimizer ("CleanStart") erhebt und wie diese verwendet werden.',
      'privacy.section1.title': '1. Welche Daten wir erheben',
      'privacy.section1.text': 'Bei der Registrierung: E-Mail-Adresse und ein gehashtes Passwort (bcrypt). Bei der Nutzung: Welche Rezepte du auswählst und wann du ein Paket generierst (für Rate-Limiting). Technische Daten: IP-Adresse und User-Agent (Standard-Webserver-Logs). Persönliche Links mit Code (z.B. cleanstart.ch/?r=firma), wie sie in Bewerbungen verwendet werden: der Code, der Zeitpunkt, Gerätetyp und Browser sowie das Land. Das wird erst erfasst, wenn du auf der Seite scrollst, klickst oder tippst. IP-Adressen werden dabei nicht gespeichert.',
      'privacy.section2.title': '2. Was wir NICHT erheben',
      'privacy.section2.text': 'Die generierten PowerShell-Skripte enthalten keinerlei Telemetrie oder Tracking. Es werden keine Daten von deinem PC an uns übermittelt. Wir haben keinen Zugriff auf dein System.',
      'privacy.section3.title': '3. Wie wir deine Daten verwenden',
      'privacy.section3.text': 'E-Mail: Für die Kontoverifizierung (6-stelliger OTP-Code), Passwort-Reset und wichtige Service-Benachrichtigungen. Nutzungsdaten: Ausschliesslich für Rate-Limiting (max. 3 Pakete/Minute, 10/Tag). Codes aus persönlichen Links: Damit der Betreiber sieht, ob ein Bewerbungslink geöffnet wurde. Diese Einträge werden nach 180 Tagen automatisch gelöscht. Dasselbe gilt für Links auf die App FlashWrite. Wir verkaufen oder teilen deine Daten nicht mit Dritten zu Werbezwecken.',
      'privacy.section4.title': '4. Drittanbieter',
      'privacy.section4.text': 'Resend: Zum Versand von Verifizierungs- und Reset-E-Mails. MongoDB Atlas: Speicherung der Kontodaten (verschlüsselt, Rechenzentrum in der EU). Vercel: Hosting der Weboberfläche. Render: Hosting des Backends.',
      'privacy.section5.title': '5. Datensicherheit',
      'privacy.section5.text': 'Passwörter werden mit bcrypt gehasht gespeichert. Die Kommunikation erfolgt über HTTPS. JWT-Tokens sind zeitlich begrenzt (7 Tage). Download-Tokens sind einmalig verwendbar und laufen nach 30 Minuten ab.',
      'privacy.section6.title': '6. Deine Rechte',
      'privacy.section6.text': 'Du kannst jederzeit die Löschung deines Kontos und aller zugehörigen Daten verlangen. Kontaktiere uns dafür per E-Mail. Gemäss dem Schweizer Datenschutzgesetz (DSG) und der EU-DSGVO hast du das Recht auf Auskunft, Berichtigung und Löschung deiner Daten.',
      'privacy.section7.title': '7. Cookies',
      'privacy.section7.text': 'CleanStart verwendet keine Tracking-Cookies. Es wird lediglich ein JWT-Token im lokalen Speicher des Browsers abgelegt, um deine Sitzung aufrechtzuerhalten. Bei persönlichen Links merkt sich der Browser für die Dauer der Sitzung, dass der Aufruf schon gemeldet wurde.',
      'privacy.section8.title': '8. Kontakt',
      'privacy.section8.text': 'Bei Fragen zum Datenschutz erreichst du uns unter: jade.chadad@outlook.com',
    }
  },
  'en-US': {
    translation: {
      // Navigation
      'nav.home': 'Home',
      'nav.wizard': 'Wizard',
      'nav.dryrun': 'Preview',
      'nav.download': 'Download',
      'nav.admin': 'Admin',
      'nav.logout': 'Logout',
      'nav.login': 'Login',
      
      // Landing Page
      'landing.hero.title': 'CleanStart PC Optimizer',
      'landing.hero.subtitle': '1-Click Windows Optimization without visible PowerShell',
      'landing.hero.cta': 'Optimize Now',
      'landing.features.title': 'Features',
      'landing.features.bloatware': 'Remove Bloatware',
      'landing.features.bloatware.desc': 'Disable unnecessary pre-installed software',
      'landing.features.privacy': 'Privacy',
      'landing.features.privacy.desc': 'Reduce telemetry and tracking',
      'landing.features.performance': 'Performance',
      'landing.features.performance.desc': 'Optimize autostarts and services',
      'landing.features.rollback': 'Safe Rollback',
      'landing.features.rollback.desc': 'All changes reversible',
      
      // Auth
      'auth.login.title': 'Login',
      'auth.login.subtitle': 'Sign in to continue',
      'auth.register.title': 'Register',
      'auth.register.subtitle': 'Create a new account',
      'auth.email': 'Email Address',
      'auth.password': 'Password',
      'auth.password.confirm': 'Confirm Password',
      'auth.password.new': 'New Password',
      'auth.password.min': 'At least 8 characters',
      'auth.login.button': 'Login',
      'auth.register.button': 'Register',
      'auth.switch.register': "Don't have an account? Register",
      'auth.switch.login': 'Already registered? Login',
      'auth.forgot': 'Forgot password?',
      'auth.verify.title': 'Verify Email',
      'auth.verify.subtitle': 'Enter the 6-digit code we sent to:',
      'auth.verify.button': 'Verify',
      'auth.verify.resend': 'Resend Code',
      'auth.verify.resent': 'New code has been sent!',
      'auth.verify.spamHint': 'If you don\'t find anything in your inbox, please check the Junk/Spam folder.',
      'auth.reset.title': 'Reset Password',
      'auth.reset.subtitle': 'Enter your email address',
      'auth.reset.send': 'Send Reset Code',
      'auth.reset.code.title': 'Enter Code',
      'auth.reset.code.subtitle': 'Enter the 6-digit reset code',
      'auth.reset.new.title': 'New Password',
      'auth.reset.new.subtitle': 'Choose a new password',
      'auth.reset.button': 'Reset Password',
      'auth.reset.success': 'Password reset successfully!',
      'auth.reset.back': 'Back to Login',
      'auth.reset.step2.next': 'Next',
      'auth.email.placeholder': 'name@example.com',

      // Toast messages
      'toast.login.success': 'Successfully logged in!',
      'toast.login.unverified': 'Email not verified. Please confirm your email.',
      'toast.login.failed': 'Login failed',
      'toast.register.passwordMin': 'Password must be at least 8 characters long',
      'toast.register.passwordMismatch': 'Passwords do not match',
      'toast.register.success': 'Registration successful! Check your emails.',
      'toast.register.failed': 'Registration failed',
      'toast.verify.incomplete': 'Please enter the complete 6-digit code',
      'toast.verify.success': 'Email successfully verified!',
      'toast.verify.failed': 'Verification failed',
      'toast.resend.failed': 'Error sending code',
      'toast.reset.codeSent': 'Reset code sent. Check your emails.',
      'toast.reset.sendFailed': 'Error sending reset code',
      'toast.reset.failed': 'Error resetting password',
      'toast.session.expired': 'Session expired, please log in again',
      'toast.session.relogin': 'Please log in again',
      'toast.download.success': 'Download successful!',
      'toast.download.failed': 'Download failed. Please try again.',
      'toast.download.noToken': 'No download token available',
      'toast.rateLimit.tooMany': 'Too many requests',
      'toast.rateLimit.daily': 'Daily limit reached. Please try again tomorrow.',

      // Wizard
      'wizard.title': 'Optimization Wizard',
      'wizard.subtitle': 'Select your desired optimizations',
      'wizard.select': 'Select',
      'wizard.selected': 'Selected',
      'wizard.next': 'Continue to Preview',
      'wizard.norecipes': 'No recipes available',
      'wizard.selectMin': 'Please select at least one recipe',
      'wizard.steps': 'Steps',
      'wizard.changes': 'Changes',

      // Categories
      'category.datenschutz': 'Privacy',
      'category.leistung': 'Performance',
      'category.komfort': 'Comfort',

      // Dry Run
      'dryrun.title': 'Change Preview',
      'dryrun.subtitle': 'Review planned changes',
      'dryrun.generate': 'Generate Package',
      'dryrun.back': 'Back',
      'dryrun.total': 'Total Changes',
      'dryrun.impact': 'Estimated Impact',
      'dryrun.changes': 'Changes',
      'dryrun.category': 'Category',
      'dryrun.category.datenschutz': 'Privacy',
      'dryrun.category.leistung': 'Performance',
      'dryrun.category.komfort': 'Comfort',
      
      // Download
      'download.title': 'Download',
      'download.subtitle': 'Your optimization package is ready',
      'download.button': 'Download ZIP',
      'download.downloading': 'Downloading...',
      'download.expires': 'Expires',
      'download.ready': 'Your optimization package is ready',
      'download.instructions.title': 'Instructions',
      'download.instructions.step1': 'Extract ZIP file',
      'download.instructions.step2': 'Run cleanstart.ps1 as Administrator',
      'download.instructions.step3': 'Done! Your PC is optimized',
      'download.warning': 'Important: Run cleanstart.ps1 as Administrator. The script automatically creates a System Restore Point.',
      'download.notAvailable': 'Download Not Available',
      'download.networkError': 'Network Error',
      'download.retry': 'Try Again',
      'download.backToWizard': 'Back to Wizard',
      'download.forbidden': 'Access Denied',
      'download.previewLoading': 'Loading preview...',
      'download.codePreview': 'Code Preview',
      'download.first50Lines': 'first 50 lines',
      'download.checksums': 'Checksums (SHA256)',
      'download.filename': 'Filename',
      'download.expired': 'Package not found or expired',
      'download.previewFailed': 'Error loading preview',
      'download.downloadFailed': 'Download failed',
      'download.linkExpired': 'Download link has expired or has already been used',
      'download.notFound': 'Package not found',
// Download – Step-by-step guide
      'download.guide.title': 'Step-by-step guide',
      'download.guide.subtitle': 'Follow these steps to run the script correctly',
      'download.guide.step1': 'Extract the ZIP file into a folder (e.g. <code>C:\\CleanStart</code>)',
      'download.guide.step2': 'Open <code>cleanstart.ps1</code> with Notepad: Right-click the file → "Open with" → "Notepad"',
      'download.guide.step3': 'In Notepad: press <code>Ctrl + A</code> (select all), then <code>Ctrl + C</code> (copy)',
      'download.guide.step4': 'Press the Windows key, type <code>PowerShell</code>, right-click "Windows PowerShell" → "Run as administrator" and confirm the UAC prompt with "Yes"',
      'download.guide.step5': '<strong>Required for every new PowerShell window:</strong> Type and press Enter (only applies to the current session): <code>Set-ExecutionPolicy -Scope Process -ExecutionPolicy Bypass -Force</code>',
      'download.guide.step6': 'Paste the copied script content with <code>Ctrl + V</code> (or right-click) and press Enter',
      'download.guide.step7': 'The script automatically creates a System Restore Point and applies the optimizations (takes 1-3 minutes)',
      'download.guide.step8': 'Restart the PC if needed',
      'download.guide.undoTitle': 'Undo changes:',
      'download.guide.undoText': 'Repeat steps 2-6 with <code>undo.ps1</code> instead of <code>cleanstart.ps1</code>. The script opens Windows System Restore.',
      // Admin
      'admin.title': 'Recipe Management',
      'admin.create': 'New Recipe',
      'admin.edit': 'Edit',
      'admin.delete': 'Delete',
      'admin.published': 'Published',
      'admin.draft': 'Draft',
      
      // Loading Screen
      'loading.serverStarting': 'Server is starting, please wait a moment...',
      'loading.serverHint': 'Free servers sometimes need a moment to wake up',
      'loading.default': 'Loading...',

      // Common
      'common.loading': 'Loading...',
      'common.error': 'Error',
      'common.success': 'Success',
      'common.cancel': 'Cancel',
      'common.save': 'Save',
      // i18n.js — en-US Block, am Ende einfügen

      // Footer
      'footer.eula': 'Terms of Use',
      'footer.privacy': 'Privacy Policy',
      'footer.copyright': '© 2026 CleanStart. All rights reserved.',

      // EULA Page
      'eula.title': 'Terms of Use (EULA)',
      'eula.lastUpdated': 'Last updated: April 24, 2026',
      'eula.intro': 'By using CleanStart PC Optimizer ("CleanStart"), you agree to these terms of use. If you do not agree, you may not use CleanStart.',
      'eula.section1.title': '1. Description of Service',
      'eula.section1.text': 'CleanStart is a web-based generator for Windows optimization scripts. Scripts are executed locally on your PC. No remote access or remote commands are performed.',
      'eula.section2.title': '2. Use at Your Own Risk',
      'eula.section2.text': 'The generated scripts modify Windows system settings (registry, services, scheduled tasks). You are solely responsible for running these scripts. CleanStart automatically creates a system restore point before each optimization, but creating an additional backup is recommended.',
      'eula.section3.title': '3. No Warranty',
      'eula.section3.text': 'CleanStart is provided "as is" without any warranty. We assume no liability for damages arising from the use of the generated scripts, including but not limited to data loss, system instability, or loss of functionality.',
      'eula.section4.title': '4. Intellectual Property',
      'eula.section4.text': 'The CleanStart software, including all scripts, recipes, and the web interface, is protected by copyright. You may use the generated scripts for personal use but may not resell them or present them as your own work.',
      'eula.section5.title': '5. Account Rules',
      'eula.section5.text': 'One account per person is permitted. You are responsible for the security of your login credentials. We reserve the right to suspend accounts in case of misuse.',
      'eula.section6.title': '6. Changes',
      'eula.section6.text': 'We may change these terms at any time. For significant changes, you will be notified by email or at your next login. Continued use after a change constitutes acceptance.',
      'eula.section7.title': '7. Governing Law',
      'eula.section7.text': 'Swiss law applies. The place of jurisdiction is the Canton of Zurich.',

      // Privacy Page
      'privacy.title': 'Privacy Policy',
      'privacy.lastUpdated': 'Last updated: October 12, 2026',
      'privacy.intro': 'This privacy policy explains what data CleanStart PC Optimizer ("CleanStart") collects and how it is used.',
      'privacy.section1.title': '1. Data We Collect',
      'privacy.section1.text': 'During registration: Email address and a hashed password (bcrypt). During use: Which recipes you select and when you generate a package (for rate limiting). Technical data: IP address and user agent (standard web server logs). Personal links with a code (e.g. cleanstart.ch/?r=company), as used in job applications: the code, the time, device type and browser, and the country. This is only recorded once you scroll, click or type on the page. IP addresses are not stored.',
      'privacy.section2.title': '2. Data We Do NOT Collect',
      'privacy.section2.text': 'The generated PowerShell scripts contain no telemetry or tracking whatsoever. No data from your PC is transmitted to us. We have no access to your system.',
      'privacy.section3.title': '3. How We Use Your Data',
      'privacy.section3.text': 'Email: For account verification (6-digit OTP code), password reset, and important service notifications. Usage data: Exclusively for rate limiting (max 3 packages/minute, 10/day). Codes from personal links: So the operator can see whether an application link was opened. These entries are deleted automatically after 180 days. The same applies to links to the FlashWrite app. We do not sell or share your data with third parties for advertising purposes.',
      'privacy.section4.title': '4. Third-Party Services',
      'privacy.section4.text': 'Resend: For sending verification and reset emails. MongoDB Atlas: Storage of account data (encrypted, data center in the EU). Vercel: Hosting of the web interface. Render: Hosting of the backend.',
      'privacy.section5.title': '5. Data Security',
      'privacy.section5.text': 'Passwords are stored hashed with bcrypt. Communication is encrypted via HTTPS. JWT tokens are time-limited (7 days). Download tokens are single-use and expire after 30 minutes.',
      'privacy.section6.title': '6. Your Rights',
      'privacy.section6.text': 'You may request deletion of your account and all associated data at any time by contacting us via email. Under the Swiss Data Protection Act (DSG) and the EU GDPR, you have the right to access, rectify, and delete your data.',
      'privacy.section7.title': '7. Cookies',
      'privacy.section7.text': 'CleanStart does not use tracking cookies. Only a JWT token is stored in your browser\'s local storage to maintain your session. For personal links, the browser remembers for the duration of the session that the visit has already been reported.',
      'privacy.section8.title': '8. Contact',
      'privacy.section8.text': 'For privacy-related questions, contact us at: jade.chadad@outlook.com',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de-CH',
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
